import { useEffect } from "react";
import { useDialogHost } from "../DialogHostMutationContext";

/**
 * Reports this dialog's lock state to DialogHost. The host counts active
 * locks across all open dialogs and toggles `body.style.overflow: hidden`
 * once when the count crosses 0↔1+. Centralizing here means nested
 * dialogs don't fight over body.style — closing an inner dialog leaves
 * the outer's lock intact.
 */
export function useDialogScrollLock(id: string, locking: boolean): void {
  const { setBodyLock } = useDialogHost();
  useEffect(() => {
    setBodyLock(id, locking);
    return () => setBodyLock(id, false);
  }, [id, locking, setBodyLock]);
}
